import styled from 'styled-components'

import { getColumnStyles, getContainerStyles } from './utils'

/**
 * @prop [isContainer] - Является ли данный элемент контейнером для flex элементов
 * @prop [isColumn] - Является ли данный элемент колонкой контейнера
 * @prop [columnSpace] - Отступ между колонками
 * @prop [rowSpace] - Отступ между рядами
 * @prop [size] - Относительный размер колонки Flex контейнера
 * @prop [columns] - Количество колонок, занимающий элемент Flex контейнера
 */
export type TStyledFlexProps = Partial<{
  isContainer: boolean
  isColumn: boolean
  columnSpace: number
  rowSpace: number
  size: number
  columns: number
}>

const StyledFlex = styled.div<TStyledFlexProps>`
  ${(props) => {
    let resultStyles = ''

    const { isContainer, isColumn } = props

    if (isContainer) {
      resultStyles += getContainerStyles(props)
    }

    if (isColumn) {
      resultStyles += getColumnStyles(props)
    }

    return resultStyles
  }}
`

export const Styled = {
  StyledFlex,
}
